import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_vbYck7txjxXb: {
	id: 'prd_vbYck2DEV27txjxXb'
	ident: 'prd_vbYck7txjxXb'
	sku: 'simple_premium_1w_4_15_4w_44_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 1
			iteration_count: 1
			price_id: 'prc_Du2Rv2DEV2xolyvLK'
			amount: 22
			amount_usd: 4.15
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 4.15
			discount: 17.85
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: null
			price_id: 'prc_4cxNr2DEV2flAeCJM'
			amount: 44
			amount_usd: 44
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_vbYck7txjxXb, SubscriptionProduct>
const prd_vbYck7txjxXb = { ident: 'prd_vbYck7txjxXb' } as typeof _prd_vbYck7txjxXb

export default prd_vbYck7txjxXb
